import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import "./index.css";
import { CollectionSpecimenSummary, CollectionSite } from "../../../types";
import { useWebServer } from "../../../providers";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import { useAppDispatch, useAppSelector } from "../../../stores/store";
import { getCollectionsSummary } from "../../../stores/reports/action";

interface props {
  collectionId?: string;
  collection?: CollectionSite;
}

const rowTitles = ["Male", "Female", "Unsure", "Count"];

const CollectionSummaryTable: React.FC<props> = ({
  collectionId = "",
  collection = undefined,
}) => {
  const dispatch = useAppDispatch();
  const { sendRequest } = useWebServer();
  const loading = useAppSelector((state) => state.reports.loading);
  const data = useAppSelector((state) => state.reports.data[0]?.data);

  useEffect(() => {
    if (collectionId !== "") {
      dispatch(
        getCollectionsSummary({
          sendRequest,
          form: { collectionSites: collection ? [collection] : [] },
        })
      );
    }
    // eslint-disable-next-line
  }, [collectionId]);

  return (
    <Box component="form" className={"runs-detail-form"}>
      {loading && (
        <div className="title-collection-summary">
          <Typography>Summary Loading</Typography>
          <CircularProgress />
        </div>
      )}
      {data && !loading && (
        <TableContainer component={Paper} className="table-collection-summary">
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell key={"sex"}>Sex</TableCell>
                {data.map((row) => (
                  <TableCell key={row.displayName} align="center">
                    {row.displayName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rowTitles.map((title) => (
                <TableRow key={title}>
                  <TableCell component="th" scope="row">
                    {title}
                  </TableCell>
                  {data.map((row) => (
                    <TableCell key={row.displayName} align="center">
                      {
                        row[
                          title.toLowerCase() as keyof CollectionSpecimenSummary
                        ]
                      }
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default CollectionSummaryTable;
